import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";

export const showUser = async (id) => {
    return axiosInstance.get('/user/'+id);
};

export const listUsers = async (page,per_page,search,userTypeFilter) => {
    return axiosInstance.get('/user/', { params: { page,per_page,search,user_type:userTypeFilter } });
};

export const listAllUsers = async (page = 1, perPage = 100, search = '', userTypeId = null) => {

    let url = `/user/all?page=${page}&per_page=${perPage}`;
    
    if (search) {
        url += `&search=${search}`;
    }
    
    if (userTypeId) {
        url += `&user_type=${userTypeId}`;
    }
    
    return axiosInstance.get(url);
};

export const updateUser = async (id,formData) => {
    formData.append('_method', 'PUT');  
    return axiosFormDataInstance.post('/user/'+id, formData);
}

export const createUser = async (formData) => {
    return axiosFormDataInstance.post('/user/', formData);
}

export const changePassword = async (oldPassword,newPassword,newPasswordConfirm) => {
    return axiosInstance.post('/user/change_password', {current_password:oldPassword,new_password:newPassword,new_password_confirmation:newPasswordConfirm});
}

export const changePasswordEdit = async (oldPassword,newPassword,newPasswordConfirm) => {
    return axiosInstance.post('/user/change_password', {current_password:oldPassword,new_password:newPassword,new_password_confirmation:newPasswordConfirm});
}

export const setUserPassword = async (token,password) => {
    return axiosInstance.post('/set-password', {token, password});
}

export const forgotPassword = async (email,password) => {
    return axiosInstance.post('/forgot-password', {email, password});
}

export const organizationStructure = async () => {
    return axiosInstance.get('/user/organization-structure');
}